import { render } from "./ImportantTickets.vue?vue&type=template&id=719efe18&scoped=true"
import script from "./ImportantTickets.vue?vue&type=script&lang=js"
export * from "./ImportantTickets.vue?vue&type=script&lang=js"

import "./ImportantTickets.vue?vue&type=style&index=0&id=719efe18&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719efe18"]])

export default __exports__